<template>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <h4>{{ $t('app.modules.product_family_detail.title') }}</h4>

        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">

                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-3">
                    <div class="form-group">
                      <img class="icon-image"  alt="" :src="icon">
                    </div>
                    <div class="form-group" >
                      <strong>{{ $t('app.modules.product_family.addEdit.headers.technical_sheet') }}</strong>

                      <div class="row" v-if="!!curTrad && !!curTrad.hojaTecnica">
                        <div class="col-12">
                          <button type="button" class="btn btn-neutral button_download" @click="openFile(curTrad.hojaTecnica)">
                            <i class="fa fa-file"></i>
                            {{ $t('app.modules.product_family.addEdit.headers.technical_sheet') }}.pdf
                          </button>
                        </div>
                      </div>
                      <div v-else class="row">
                        <div class="col-12">
                          {{ $t('app.modules.product_family_detail.errors.not_available') }}
                        </div>
                      </div>

                    </div>
                    <div class="form-group" >
                      <strong>{{ $t('app.modules.product_family.addEdit.headers.safety_sheet') }}</strong>

                      <div class="row" v-if="!!curTrad && !!curTrad.hojaSeguridad">
                        <div class="col-12">
                          <button type="button" class="btn btn-neutral button_download" @click="openFile(curTrad.hojaSeguridad)">
                            <i class="fa fa-file"></i>
                            {{ $t('app.modules.product_family.addEdit.headers.safety_sheet') }}.pdf
                          </button>
                        </div>
                      </div>
                      <div v-else class="row">
                        <div class="col-12">
                          {{ $t('app.modules.product_family_detail.errors.not_available') }}
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="col-3">
                    <div class="form-group">
                      <strong>{{ product_family.productoPadre }}</strong>
                    </div>
                    <div class="form-group">
                      <label>{{ curTrad != null ? curTrad.descripcion : "" }}</label>
                    </div>

                    <div v-for="group in groups">
                      <div class="form-group">
                        <strong>{{ group.name }}</strong>

                        <div class="row" style="margin-top: 10px">
                          <div v-for="prop in group.propiedades" :class="prop.tipo === 'image' || prop.tipo === 'file' ? 'col-3' : 'col-12'">
                            <template v-if="prop.tipo === 'image'">
                              <img style="width: 100%" alt="" :src="prop.valorPropiedad" />
                            </template>
                            <template v-else-if="prop.tipo === 'text'">
                              <label>{{ prop.nombrePropiedad }} {{ prop.valorPropiedad }}</label>
                            </template>
                            <template v-else-if="prop.tipo === 'file'">

                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <strong>{{ $t("app.modules.product_family_detail.headers.feature") }}</strong>
                    </div>

                    <div class="row">
                      <div class="col-6" v-for="(filter, index) in filters">
                        <div class="form-group" v-if="index === 0 || !!filters[index-1].value">
                          <label>{{ filter.name }}</label>
                          <el-select
                            :placeholder="filter.name"
                            size="large"
                            @change="changeOption(index)"
                            v-model="filter.value"
                          >
                            <el-option
                              v-for="(value, ind) in filtersData[index]" v-if="value !== undefined"
                              :key="'value-'+index+'-'+ind"
                              :label="value.name"
                              :value="value.name"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-top: 15px">
                      <div class="col-12">
                        <div class="form-group">
                          <label>{{ $t("app.modules.product_family_detail.headers.mailing_address") }}</label>

                          <el-select
                            :placeholder="$t('app.modules.product_family_detail.headers.select_address')"
                            size="large"
                            v-model="direccionId"
                            @change="changeOption"
                          >
                            <el-option
                              v-for="(ad, index) in addresses"
                              :key="'address-'+index"
                              :label="ad.direccionString"
                              :value="ad.idDireccion"
                            >
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-top: 15px">
                      <div class="col-6">
                        <div class="form-group">
                          <fg-input
                            type="number"
                            :label="$t('app.modules.product_family_detail.headers.quantity') + ' '+ (unidad.length > 0 ? '('+unidad+')' : (price > 0 ? '' : '(TON)'))"
                            v-model="quantity"
                          >
                          </fg-input>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group">
                          <label>{{ $t('app.modules.product_family_detail.headers.delivery_date') }}</label>
                          <el-date-picker v-model="delivery_date" format="dd-MM-yyyy" type="date"/>
                        </div>
                      </div>
                    </div>

                    <div class="row" style="margin-top: 15px">
                      <div class="col-6">
                      </div>
                      <div class="col-6">
                        <div class="form-group" style="text-align: right">
                          <label>{{ $t('app.modules.product_family_detail.headers.price') }}</label>
                          <h3>{{ priceTitle }}</h3>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div
                  slot="footer"
                  style="margin-top: 10px; padding-top: 20px;border-top: outset;"
                  class="text-right"
                >
                  <n-button v-if="price > 0"  native-type="button" @click.native="addProducto" type="primary">{{ $t("app.buttons.add") }}</n-button>
                  <n-button v-else native-type="button" @click.native="crearCotizacion" type="primary">{{ $t("app.buttons.quote") }}</n-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <most-viewed/>

  </div>
</template>

<script>
import FamiliaProducto from "@/models/familiaProducto/FamiliaProducto";
import {getResponse, number_format} from "@/util/utilities";

export default {
  name: "detalleFamiliaProducto",
  components: {
    MostViewed: () => import("./mostViewed")
  },
  computed: {
    filtersData() {
      let result = [];

      let count = 0;
      for (const filter of this.filters) {
        if(count === 0)result.push(this.tableData[count]);

        if(!!filter.value){
          let nextIndex = count+1;
          if((nextIndex) <= this.filters.length-1){
            let ids = this.getIds(this.tableData[count], filter.value);

            if(ids.length > 0){
              let subdata = [];
              ids.forEach(val => {
                subdata.push(this.tableData[nextIndex][val]);
              });
              result.push(subdata);
            }
          }
        }
        else break;
        count++;
      }

      return this.eliminarRepetidos(result);
    },
    priceTitle() {
      return this.price === 0 ? this.$t('app.modules.product_family_detail.errors.not_available') : this.price + " " + this.moneda + "/" + this.unidad;
    }
  },
  data() {
    return {
      idFamilia: 0,
      product_family: new FamiliaProducto(),
      curTrad: null,
      icon: "",
      groups: [],
      features: [],
      products: [],
      filters: [],
      tableData: [],
      addresses: [],
      quantity: 0,
      delivery_date: "",
      direccionId: "",
      price: 0,
      moneda: "",
      unidad: "",
      idProductoCliente: 0
    }
  },
  async mounted() {
    this.init();
  },
  methods: {
    number_format,
    async init(){
      this.reset();
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      if (!!this.$route.params.idFamilia) {
        await this.loadProductFamily(parseInt(this.$route.params.idFamilia));
      }

      this.$swal.close();
    },
    async loadProductFamily(id){
      this.product_family.idFamiliaProducto = id;

      let param = {
        claveIdioma: this.$store.state.lang,
        id: id,
        usuario: 0
      };

      let request = await this.$http.put(route("FamiliasProducto/getFamiliaProducto"), param);
      let response = getResponse(request, null);

      if(response){
        this.increaseViews(id);
        this.product_family = response.familiasProductos[0];

        if(!!this.product_family.iconografia){
          let icons = this.product_family.iconografia;
          let json = JSON.parse(icons);
          if(json.length > 0){
            this.icon = json[0];
          }
        }

        let trad = this.product_family.traducciones.filter(t => t.idioma.clave === this.$store.state.lang);
        if(!!trad){
          this.curTrad = trad[0];
        }

        if(this.product_family.propiedades != null){
          this.product_family.propiedades.forEach(prop => {
            let g = this.groups.filter(g => g.id === prop.grupoPropiedadFamiliaProducto.idGrupoPropiedad);

            if(g.length === 0){
              let group = {
                id: prop.grupoPropiedadFamiliaProducto.idGrupoPropiedad,
                name: prop.grupoPropiedadFamiliaProducto.nombreGrupo,
                propiedades: []
              };

              group.propiedades.push(prop);
              this.groups.push(group);
            }
            else g[0].propiedades.push(prop);
          });
        }

        param.idFamiliaProducto = id;
        let requestProd = await this.$http.post(route("Productos/getProductosByFamilia"), param);
        let responseProd = getResponse(requestProd);

        if(responseProd != null){
          let productos = this.products =  responseProd.productos;

          productos.forEach(producto => {
            if(producto.caracteristicasProductos.length > 0){
              producto.caracteristicasProductos.forEach(caract => {
                if(!this.filters.find(f => f.id === caract.idcaracteristicasProducto)){
                  this.filters.push({
                    id: caract.idcaracteristicasProducto,
                    name: caract.nombreAtributo,
                    value: ""
                  });
                }
              });
            }
          });

          if(this.filters.length > 0){
            let cProduct = 0;
            productos.forEach(producto => {
              if(producto.caracteristicasProductos.length > 0){
                producto.caracteristicasProductos.forEach(caract => {
                  let index = this.filters.findIndex(f => f.id === caract.idcaracteristicasProducto);

                  if(!this.tableData[index]) this.tableData[index] = [];

                  let json = JSON.parse(caract.valorAtributo);

                  this.tableData[index][cProduct] = {
                    id: cProduct,
                    name: json[caract.valorCaracteristica],
                    idProducto: producto.idProducto
                  };
                });
              }
              cProduct++;
            });
          }
        }

        if(this.$store.state.user.idClienteSAP > 0){
          let paramClient = {
            clienteId: this.$store.state.user.idClienteSAP
          };
          let requestDir = await this.$http.post(route("Clientes/getDireccionesByCliente"), paramClient);
          let responseDir = getResponse(requestDir);

          if(responseDir != null){
            this.addresses = responseDir.direcciones;
          }
        }

      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));
    },
    async crearCotizacion(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      try {
        let param = {
          cliente_idCliente: this.$store.state.user.idCliente,
          producto_idProducto: this.getProducto(),
          direccionEntrega_idDireccionEntrega: this.direccionId,
          usuarios_idSolicitante: this.$store.state.user.idUsuario,
          usuarios_idUsuario: this.$store.state.user.idUsuario
        };

        if(!param.direccionEntrega_idDireccionEntrega) throw new Error(this.$t("app.modules.product_family_detail.errors.no_direction"));
        if(!param.producto_idProducto) throw new Error(this.$t("app.modules.product_family_detail.errors.no_product"));
        if(!param.cliente_idCliente) throw new Error(this.$t("app.modules.product_family_detail.errors.no_client"));

        let payload = {
          claveIdioma: this.$store.state.lang,
          cotizacion: param
        };

        let request = await this.$http.post(route("Cotizacion/addCotizacion"), payload);
        let response = getResponse(request, null);

        if(response != null){
          this.$swal.fire({
            text: this.$t("app.modules.product_family_detail.messages.quote_success"),
            showConfirmButton: true
          });

          this.notifyMessage("success", this.$t("app.promps.save_success"));
        }
        else {
          this.notifyMessage("danger", this.$t("app.promps.error"));
          this.$swal.close();
        }
      }
      catch (e){
        this.notifyMessage("danger", e.message);
        this.$swal.close();
      }
    },
    getProducto(){
      let ids = [];
      let countVals = 0;
      this.filters.forEach((filter, index) => {
        if(!!filter.value){
          countVals++;
          if(ids.length === 0){
            this.tableData[index].forEach((sub, subindex) => {
              if(sub !== undefined && sub.name === filter.value) ids.push(subindex);
            });
          }
          else if(ids.length > 1) {
            let temIds = [];
            ids.forEach(val => {
              if(this.tableData[index][val] !== undefined && filter.value === this.tableData[index][val].name) temIds.push(val);
            });
            ids = temIds;
          }
        }
      });

      return ids.length < 1 || countVals !== this.filters.length ? null : this.tableData[0][ids[0]].idProducto;
    },
    async loadPrecio(){
      let param = {
        direccionId: this.direccionId,
        productoId: this.getProducto(),
        clienteIdSAP: this.$store.state.user.idClienteSAP
      };
      //console.log(param);
      this.price = 0;
      this.moneda = "";
      this.unidad = "";
      this.idProductoCliente = 0;

      if(!param.direccionId || !param.productoId || !param.clienteIdSAP) return;

      let request = await this.$http.put(route("Productos/getPrecioByProducto"), param);
      let response = getResponse(request, null);

      if(response && response.productos.length > 0){
        let producto = response.productos[0];
        this.price = producto.precioUnitario;
        this.moneda = producto.moneda;
        this.unidad = producto.unidadMedida;
        this.idProductoCliente = producto.idProductoCliente;
      }
    },
    addProducto(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      try{
        let payload = {idProductoCliente: this.idProductoCliente, cantidad: this.quantity, fechaEntrega: this.delivery_date}

        if(!payload.idProductoCliente) throw new Error(this.$t("app.modules.product_family_detail.errors.no_client"));
        if(!payload.cantidad) throw new Error(this.$t("app.modules.product_family_detail.errors.no_quantity"));
        if(!payload.fechaEntrega) throw new Error(this.$t("app.modules.product_family_detail.errors.no_delivery_date"));

        EventBus.$emit("add-to-cart", payload);
      }
      catch (e){
        this.notifyMessage("danger", e.message);
      }
      finally {
        this.$swal.close();
      }
    },
    openFile(file){
      window.open(file, "_blank");
    },
    changeOption(filterIndex){
      //console.log('Entra aqui-filtro');
      for(let i = filterIndex; i < this.filters.length-1; i++){
        this.filters[i+1].value = "";
      }
      this.loadPrecio();
    },
    eliminarRepetidos(result){
      let response = [];
      result.forEach(data => {
        let nData = [];
        data.forEach(sub => {
          if(sub !== undefined){
            let ind = nData.findIndex(i => i.name === sub.name);
            if(ind === -1) nData.push(sub);
          }
        });
        response.push(nData);
      });
      return response;
    },
    getIds(data, value){
      let ids = [];
      data.forEach((filter, index) => {
        if(filter.name === value) ids.push(index);
      });
      return ids;
    },
    async increaseViews(id){
      let request = await this.$http.put(route("FamiliasProducto/increaseViews"), {id: id});
      let response = getResponse(request);
    },
    reset(){
        this.idFamilia = 0;
        this.product_family = new FamiliaProducto();
        this.curTrad = null;
        this.icon = "";
        this.groups = [];
        this.features = [];
        this.products = [];
        this.filters = [];
        this.tableData = [];
        this.addresses = [];
        this.quantity = 0;
        this.delivery_date = "";
        this.direccionId = "";
        this.price = 0;
        this.moneda = "";
        this.unidad = "";
        this.idProductoCliente = 0;
    }
  },
  watch: {
    $route(to, from) {
      this.init();
    }
  }
}
</script>

<style>

</style>
<style scoped>
.icon-image {
  width: 100%;
  border-radius: 10px;
}
.button_download {
  color: #2c2c2c !important;
  font-size: 13px !important;
  padding-left: 0;
  margin: 0;
}
.button_download > i {
  font-size: 30px !important;
  padding-right: 20px !important;
  color: #e83734;
}
</style>
